/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { ApiSrc } from "../../../resources/ApiSrc";
import { GetResultObject, PostRequest } from "../../API";

const TYPES = {
    REQUEST_BUNDLE_LIST: "REQUEST_BUNDLE_LIST",  
    REQUEST_BUNDLE_LIST_SUCCESS: "REQUEST_BUNDLE_LIST_SUCCESS",
    REQUEST_BUNDLE_LIST_FAILED: "REQUEST_BUNDLE_LIST_FAILED",

    REQUEST_UPDATE_BUNDLE_STATUS_SUCCESS: "REQUEST_UPDATE_BUNDLE_STATUS_SUCCESS",
    REQUEST_CREATE_BUNDLER_SUCCESS: "REQUEST_CREATE_BUNDLER_SUCCESS"
};
  
const getBundleList = (body, params) => {
    return (dispatch) => {
      dispatch({
        type: TYPES.REQUEST_BUNDLE_LIST,
        payload: {},
      });
      PostRequest(
          ApiSrc.GET_BUNDLE_LIST, body, params
      ).then(result => {
        GetResultObject(result, 'data.content', 200, (data, page) => {
          dispatch({
            type: TYPES.REQUEST_BUNDLE_LIST_SUCCESS,
            payload: {data: data, ...page},});
          })    
       })
  
    }
}

const updateBundleStatus = (body) => {
  return (dispatch) => {   
    PostRequest(
        ApiSrc.UPDATE_BUNDLE_STATUS, body
    ).then(result => {
      GetResultObject(result, 'data', 200, (data) => {
        dispatch({type: TYPES.REQUEST_UPDATE_BUNDLE_STATUS_SUCCESS, payload: {data: data}});
      })    
    })
  }
}

const createBundleSuccess = (data) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_CREATE_BUNDLER_SUCCESS,
      payload: {data: data},
    }); 
  }
}

export default {
    TYPES, getBundleList, updateBundleStatus, createBundleSuccess
}